import { enhancedRequest, streamRequest } from '../utils/request.js'

// 普通请求
const sendMsg = data => enhancedRequest({
  url: `/selfstudy-app/ai/assistant/chat/completions`,
  method: 'post',
  data
})

// 创建新对话
const newChat = data => enhancedRequest({
  url: `/selfstudy-app/ai/assistant/chat/new`,
  method: 'post',
  data
})

// 关闭对话
const closeMsg = data => enhancedRequest({
  url: `/selfstudy-app/ai/assistant/chat/${data.chatRecordId}`,
  method: 'delete',
  data
})

// 拿到华为云的token
const getHuaweiToken = () => enhancedRequest({
  url: `/selfstudy-app/ai/assistant/sis/getAuthToken`,
  method: 'get'
})

// 流式请求
const sendStreamMsg = (data, onMessage) => streamRequest({
  url: `/selfstudy-app/ai/assistant/chat/completions`,
  method: 'post',
  data
}, onMessage)

// 获取聊天模板类型
const getChatType = () => enhancedRequest({
  url: `/selfstudy-app/ai/assistant/chat/prompt`,
  method: 'get'
})

// 获取聊天记录
const getHistory = (data) => enhancedRequest({
  url: `/selfstudy-app/ai/assistant/chat/page`,
  method: 'get',
  data,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 删除聊天记录
const delChat = (chatRecordId) => enhancedRequest({
  url: `/selfstudy-app/ai/assistant/del/chat/${chatRecordId}`,
  method: 'delete',
})

// 获取单条聊天记录
const getHistoryById = (chatRecordId) => enhancedRequest({
  url: `/selfstudy-app/ai/assistant/chat/${chatRecordId}`,
  method: 'get',
})

// 获取聊天快捷回复文本
const getTips = (chatRecordId) => enhancedRequest({
  url: `/selfstudy-app/ai/assistant/chat/quick/reply/${chatRecordId}`,
  method: 'get',
})

// 获取年纪和册次
const getGrade = () => enhancedRequest({
  url: `/selfstudy-app/stage/papers/chinese/grade/volume/list`,
  method: 'get',
})

// 语音转文本
const mp3ToText = (data) => enhancedRequest({
  url: `/selfstudy-app/ai/assistant/sis/mp3ToText`,
  method: 'post',
  data
})

// 错题本-ai解析
const getQuestion = (data) => enhancedRequest({
  url: `/selfstudy-app/user/topicInfo`,
  method: 'get',
  data
})

// 流式请求
const errorQAiAnalysis = (data, onMessage) => streamRequest({
  url: `/selfstudy-app/user/ai/analysis/completions`,
  method: 'post',
  data
}, onMessage)

export {
  sendMsg,
  sendStreamMsg,
  closeMsg,
  getChatType,
  getHistory,
  getHistoryById,
  getHuaweiToken,
  newChat,
  delChat,
  getTips,
  getGrade,
  mp3ToText,
  errorQAiAnalysis,
  getQuestion
}

